import React, { memo } from 'react';
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Bounds",
  x: "0",
  y: "0",
  width: "32",
  height: "32"
});
const FormsIcon = _ref => {
  let {
    className,
    color = '#B5BDC5'
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg/form",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Other-Colors/32px/Lists/forms"
  }, _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M15.2479339,19.5454545 L10.0909091,24.2727273 L5.73684211,24.2727273 C4.23157895,24.2727273 3,23.0296023 3,21.5102273 L3,5.7625 C3,4.243125 4.23157895,3 5.73684211,3 L21.5358852,3 C23.0411483,3 24.2727273,4.243125 24.2727273,5.7625 L24.2727273,11.2727273 L20.7272727,14.5227273 L20.7272727,12.4545455 L6.54545455,12.4545455 L6.54545455,14.8181818 L20.4049587,14.8181818 L17.8264463,17.1818182 L6.54545455,17.1818182 L6.54545455,19.5454545 L15.2479339,19.5454545 Z M20.7272727,10.0909091 L20.7272727,7.72727273 L6.54545455,7.72727273 L6.54545455,10.0909091 L20.7272727,10.0909091 Z M25.7157895,19.445933 L16.1617225,29 L12.5789474,29 L12.5789474,25.4172249 L22.1330144,15.8631579 L25.7157895,19.445933 Z M28.733269,16.2653061 L26.9459436,18.0526316 L23.5263158,14.6330038 L25.3136412,12.8456783 C25.6692825,12.490037 26.24378,12.490037 26.5994213,12.8456783 L28.733269,14.9795261 C29.0889103,15.3351674 29.0889103,15.9096648 28.733269,16.2653061 Z",
    id: "Combined-Shape",
    fill: color,
    fillRule: "evenodd"
  }))));
};
export default /*#__PURE__*/memo(FormsIcon);